export const ADMINISTRATION_ACCESS = `
  Users with administration access will have permissions to manage account
  settings for users, teams and more. If needed, you can restrict administration access to certain locations.
`;
export const ADMIN_LOCATIONS = `
  You can select the locations this user will have administration access to.
  This way they will only be able to manage settings that are associated with certain locations.
`;
export const ROLE = `
  Select a role that best describes this user's main responsibilities. Don't see what you need?
  Custom roles can be created on Roles & Permissions page.
`;
export const ROLE_FOR_OTHER_LOCATIONS = `
  Users that have administration access to certain locations still need a role.
  This way we can give them the proper permissions for the managing settings on locations they are not an admin for.
`;
export const EMAIL_ADDRESS =
  'This email address will also be the username for login.';

export const LICENSES_ASSIGNED_USER =
  'Need to remove main license? Deactivate user from the user page.';

export const PRIMARY_TEAM = `
  A user may need to be in multiple teams to perform their job,
  however their primary team should be the main team/department that they are actually in.
  Teams can be used to route calls and other communication channels as well as other smart defaults throughout the platform.
`;
